import React from 'react';
import styles from './styles.module.scss';

const BackStep = ({ onClickEvent }) => {
  return (
    <div className={styles.backStepLink} onClick={onClickEvent}>
      <i className="material-icons">keyboard_arrow_left</i>
      <div>Back a step</div>
    </div>
  );
};

export default BackStep;
